export const enrollButtonBaseStyles =
  "text-center content-center items-center min-w-full md:min-w-32 py-2 justify-center disabled:opacity-25 rounded-full px-6";
